import React from 'react';

import { CheckboxFieldIcon } from 'src/components/icons/CheckboxFieldIcon';
import { DateFieldIcon } from 'src/components/icons/DateFieldIcon';
import { DropdownFieldIcon } from 'src/components/icons/DropdownFieldIcon';
import { IinBoxIcon } from 'src/components/icons/IinBoxIcon';
import { NumberIcon } from 'src/components/icons/NumberIcon';
import { RadioButtonIcon } from 'src/components/icons/RadioButtonIcon';
import { Apollo } from 'src/gql/generated';

interface VariableTypeIconProps extends React.HTMLAttributes<HTMLElement> {
  variant: Apollo.MetadataVariant;
}

export function VariableTypeIcon({ className, variant }: VariableTypeIconProps): JSX.Element {
  switch (variant) {
    case Apollo.MetadataVariant.Date:
      return <DateFieldIcon className={className} />;
    case Apollo.MetadataVariant.Email:
    case Apollo.MetadataVariant.Text:
      return <IinBoxIcon className={className} />;
    case Apollo.MetadataVariant.Currency:
    case Apollo.MetadataVariant.Decimal:
      return <NumberIcon className={className} />;
    case Apollo.MetadataVariant.Checkbox:
      return <CheckboxFieldIcon className={className} />;
    case Apollo.MetadataVariant.Options:
      return <DropdownFieldIcon className={className} />;
    case Apollo.MetadataVariant.RadioOptions:
      return <RadioButtonIcon className={className} />;
  }
}
